import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
export class GetCurrentUserUseCaseImpl {
    constructor(authRepository, userRepository) {
        this.authRepository = authRepository;
        this.userRepository = userRepository;
    }
    run() {
        return this.authRepository.userId.pipe(switchMap(id => this.findUserById(id)));
    }
    findUserById(id) {
        if (!id)
            return of(undefined);
        return this.userRepository.findUserById(id);
    }
}
